let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("5GTY9")]).then(() => parcelRequire('8nmH7'));